import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import dayjs from '@aqx-core/common/dayjs';
import { useCompanyLoading, useServerTimezoneOffset } from '@aqx-core/common/services/company';
import { isTruthyOrZero } from '@aqx-core/common/validators';

const TIMEZONE_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const TIMEZONE_DISPLAY_FORMAT_DATE = 'YYYY-MM-DD';

interface IServerTimeProps {
  timestamp: number;
  serverTime: boolean;
  dateOnly?: boolean;
}

export const useMarketTime = (props: IServerTimeProps) => {
  const { timestamp, serverTime, dateOnly } = props;
  const { t } = useTranslation();

  const timezoneOffset = useServerTimezoneOffset();
  const loading = useCompanyLoading();

  const [displayTimeLabel, displayTime] = useMemo(() => {
    if (loading) {
      return ['', ''];
    }

    if (isTruthyOrZero(timezoneOffset) && serverTime) {
      return [
        t('Server Time'),
        dayjs(timestamp)
          .utcOffset(timezoneOffset as number)
          .format(dateOnly ? TIMEZONE_DISPLAY_FORMAT_DATE : TIMEZONE_DISPLAY_FORMAT)
      ];
    }

    return [
      t('Device Time'),
      dayjs(timestamp).format(dateOnly ? TIMEZONE_DISPLAY_FORMAT_DATE : TIMEZONE_DISPLAY_FORMAT)
    ];
  }, [loading, timezoneOffset, serverTime, timestamp, dateOnly, t]);

  return {
    timezoneOffset,
    loading,
    displayTimeLabel,
    displayTime
  };
};
